<template>
  <footer class="footer">
    <div class="footer__content">
      <div class="footer__box">
        <div class="footer-left">
          <div class="footer-left__logo">
            <SvgLogo/>
          </div>
        </div>
        <div class="footer-middle">
          <div class="footer-header">
            <h3 class="footer-header__heading">BRÖDERNA KLEMENSSONS FJÄLLKÖTT</h3>
          </div>
          <div class="footer-text">
            <p class="footer-text__paragraph">Renkött är det mest naturliga kött du kan köpa som är producerat i Sverige. Renen har levt sitt liv i frihet i våra fjäll och skogar. Född på samma snöklädda fjällsidor som sina föregångare. Vi väljer ut fina slaktdjur under höstens skiljning och säljer välstyckat, välpaketerat och uppmärkt kött direkt till dig som kund.</p>
          </div>
        </div>
        <div class="footer-right">
          <div class="footer-right__top">
            <a :href="fbRoute" target="_blank" class="footer-social">
              <div class="footer-social__inner">
                <div class="footer-social-icon">
                  <img src="/static/images/Facebook-icon.svg" alt="Facebook ikon"/>
                </div>
                <div class="footer-social-text">Följ oss</div>
              </div>
            </a>
            <a :href="instagramRoute" target="_blank" class="footer-social">
              <div class="footer-social__inner">
                <div class="footer-social-icon">
                  <img src="/static/images/instagram.svg" alt="Instagram ikon"/>
                </div>
                <div class="footer-social-text">Följ oss</div>
              </div>
            </a>
            <!--<a :href="shareRoute" target="_blank" class="footer-share">
              <div class="footer-share__inner">
                <div class="footer-share-icon">
                  <img src="/static/images/Send-icon.svg" alt="Facebook ikon"/>
                </div>
                <div class="footer-share-text">Dela</div>
              </div>
            </a>-->
          </div>
          <div class="footer-copyright">
            <span class="footer-copyright__text"><span>©</span> 2026 Bröderna Klemenssons Fjällkött</span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'AppFooter',
  computed: {
    fbRoute () {
      return 'https://www.facebook.com/Br%C3%B6derna-Klemenssons-fj%C3%A4llk%C3%B6tt-101068067954951/'
    },
    instagramRoute () {
      return 'https://www.instagram.com/broderna_klemenssons'
    },
    shareRoute () {
      return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(window.location.href)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './app-footer'
</style>



// WEBPACK FOOTER //
// src/components/AppFooter/AppFooter.vue